import { isBoolean } from "presentation/utils/functions/generic";

// Stages methods
// Carrega um item no state
export const loadStage = (key, component) => {
    const { stages } = component.state;
    let output = undefined;

    if (stages.length > 0) {
        var item = stages.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }

    return output;
}

// Monta a lista no state
export const mountStageItems = (component) => {

    const { totalStageItems, stages } = component.state;

    const deleteRequested = stages.filter(x => x.isDeleteRequested === true);

    let newStages = [];

    for (let i = 0; i < totalStageItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultItemId = null;
        let defaultEvaluationSchemeId = null;
        let defaultIsMainStage = false;
        let defaultName = undefined;
        let defaultTempId = undefined;
        let defaultIsVirtualId = false;

        let stage = loadStage(itemKey, component);
        
        let newItem = {
            key: itemKey,
            id: defaultItemId,
            tempId: defaultTempId,
            isVirtualId: defaultIsVirtualId,
            evaluationSchemeId: defaultEvaluationSchemeId,
            name: defaultName,
            isMainStage: defaultIsMainStage
        };

        if (stage !== undefined) {
            newItem = { ...stage };
        }

        newStages.push(newItem);
    }

    let finalStages = [...newStages, ...deleteRequested];

    component.setState({ stages: finalStages });
}

//Carrega as informações de um campo específico do item no state
export const stagesFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadStage(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangeStages = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');
    const isTrueUnique = (event.target.getAttribute('data-field-is-true-unique') === "true");
    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component, isTrueUnique);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component, isTrueUnique = false) => {
    var item = loadStage(key, component);
    item = { ...item, [field]: value };

    const newStages = changeStagesList(component, item);

    let finalOptions = beforeChangeStagesState(key, field, value, newStages, component, isTrueUnique);

    component.setState({
        stages: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangeStagesState = (key, changedField, changeValue, newStages, component, isTrueUnique = false) => {


    // Coloca um id temporário para stages que não tiverem esse dado
    let output = newStages.map((le, i) => {
        if (!le.id) {
            let tempId = generateStageVirtualId();
            return { ...le, id: tempId, tempId: tempId, isVirtualId: true };
        } else {
            return le;
        }
    });


    //Apenas um item desse tipo de campo pode ser true
    if (isTrueUnique == true && isBoolean(changeValue) && changeValue === true) {
        output = newStages.map((e, i) => {
            if (e.key !== key) {
                e[changedField] = false;
            }
            return e;
        });
    }


    return output;
}

export const generateStageVirtualId = () => {
    return `temp-stage-${new Date().getTime()}`;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changeStagesList = (component, targetOption, remove = false) => {
    let { stages } = component.state;

    let optionIndex = stages.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = stages[optionIndex]['id'] || undefined;
        let isVirtualId = stages[optionIndex]['isVirtualId'] || false;

        let isApiDeleteRequired = isVirtualId ? false : (elementId ? true : false);

        if (isApiDeleteRequired) {
            stages[optionIndex]['isDeleteRequested'] = true;
            stages[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            stages.splice(optionIndex, 1);
        }
    } else {
        stages[optionIndex] = targetOption;
    }

    return stages;
}


const stagesFunctions = {
    loadStage,
    stagesFormValue,
    handleChangeStages,
    beforeChangeStagesState,
    changeStagesList,
    mountStageItems,
    generateStageVirtualId
}

export default stagesFunctions;